import React from "react";
import "./AdminPage.css";

const DeleteAlert = ({ show, onClose, handleDelete }) => {
  if (!show) return null;

  return (
    <div className="popup_overlay">
      <div className="alert_delete">
        <h5>Confirm Delete</h5>
        <div className="verify">
          <button onClick={handleDelete}>Ok</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAlert;
